import React from 'react';

import { CustomModal, Flex, UiButton } from '@shared/ui';

export const AccountEditFooter = ({ onCancel, onSuccess, isArchive, t }) => (
    <CustomModal.Footer>
        <Flex fullWidth justify="between">
            <UiButton
                onClick={onCancel}
                btnColor="secondary"
                btnText={
                    isArchive
                        ? t('AccountEditFooter.return.close')
                        : t('AccountEditFooter.return.cancel')
                }
            />

            {!isArchive && (
                <UiButton onClick={onSuccess} btnText={t('AccountEditFooter.return.save')} />
            )}
        </Flex>
    </CustomModal.Footer>
);
